import React, { useEffect, useState } from 'react';
import './ContactPage.css';
import LanternLabs1 from '../assets/LanternLabs1.png';
import LanternLabs2_1 from '../assets/LanternLabs2-1.png';
import LanternLabs2 from '../assets/LanternLabs2.png';
import LanternLabs3copy from '../assets/LanternLabs3copy.png';
import LanternLabs3_1 from '../assets/LanternLabs3-1.png';
import LanternLabs3 from '../assets/LanternLabs3.png';

const ContactPage = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        industry: '',
        program: '',
        message: ''
    });
    const [status, setStatus] = useState({ type: '', message: '' });
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
        // Render reCAPTCHA widget if grecaptcha is loaded
        const renderRecaptcha = () => {
            if (window.grecaptcha && window.grecaptcha.render && document.querySelector('.g-recaptcha')) {
                // Only render if not already rendered
                if (!document.querySelector('.g-recaptcha > div')) {
                    try {
                        window.grecaptcha.render(document.querySelector('.g-recaptcha'), {
                            sitekey: process.env.REACT_APP_RECAPTCHA_SITE_KEY
                        });
                    } catch (error) {
                        console.error('reCAPTCHA render error:', error);
                    }
                }
            }
        };
        // Try immediately, then retry if grecaptcha not loaded yet
        renderRecaptcha();
        const interval = setInterval(renderRecaptcha, 500);
        setTimeout(() => clearInterval(interval), 5000); // Stop after 5s
        return () => clearInterval(interval);
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Get reCAPTCHA response
        if (!window.grecaptcha || !window.grecaptcha.getResponse) {
            setStatus({ type: 'error', message: '⚠️ reCAPTCHA is not loaded. Please refresh and try again.' });
            return;
        }

        let recaptchaToken = '';
        try {
            recaptchaToken = window.grecaptcha.getResponse();
        } catch (error) {
            console.error('reCAPTCHA getResponse error:', error);
        }

        if (!recaptchaToken) {
            setStatus({ type: 'error', message: '⚠️ Please complete the reCAPTCHA checkbox' });
            return;
        }

        setIsSubmitting(true);
        setStatus({ type: 'sending', message: '📤 Sending your message...' });

        try {
            const response = await fetch('/api/send-email', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    ...formData,
                    recaptchaToken
                }),
            });

            if (response.ok) {
                setStatus({ type: 'success', message: '✅ Message sent successfully! Check your email inbox.' });
                setFormData({ name: '', email: '', industry: '', program: '', message: '' });
                if (window.grecaptcha && window.grecaptcha.reset) {
                    window.grecaptcha.reset();
                }
            } else {
                setStatus({
                    type: 'error',
                    message: (
                        <span>
                            Unable to send the form data at this movement, Please mail us at <a href="mailto:info@lanternpharma.com" className="status-link">info@lanternpharma.com</a>
                        </span>
                    )
                });
                if (window.grecaptcha && window.grecaptcha.reset) {
                    window.grecaptcha.reset();
                }
            }
        } catch (error) {
            setStatus({
                type: 'error',
                message: (
                    <span>
                        Unable to send the form data at this movement, Please mail us at <a href="mailto:info@lanternpharma.com" className="status-link">info@lanternpharma.com</a>
                    </span>
                )
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="contact-page-container">
            <main className="contact-main">
                <section className="contact-hero-section">
                    {/* Background Text Decoration */}
                    <div className="contact-bg-text-container">
                        <div className="contact-bg-text-wrapper">
                            <h1 className="contact-bg-text lantern">LANTERN</h1>
                        </div>
                        <div className="contact-bg-text-wrapper">
                            <h1 className="contact-bg-text labs">LABS</h1>
                        </div>
                    </div>

                    {/* Scattered Decorative Images */}
                    <img src={LanternLabs1} alt="" className="hero-bg-decor hero-decor-1" />
                    <img src={LanternLabs2_1} alt="" className="hero-bg-decor hero-decor-2" />
                    <img src={LanternLabs2} alt="" className="hero-bg-decor hero-decor-3" />
                    <img src={LanternLabs3copy} alt="" className="hero-bg-decor hero-decor-4" />
                    <img src={LanternLabs3_1} alt="" className="hero-bg-decor hero-decor-5" />
                    <img src={LanternLabs3} alt="" className="hero-bg-decor hero-decor-6" />

                    <div className="contact-header-section">
                        <div className="contact-title-container">
                            <h1 className="contact-title">Let's make it happen</h1>
                        </div>
                        <div className="contact-subtitle-container">
                            <p className="contact-subtitle">
                                Got questions about your project? Need an expert evaluation? <br />
                                Reach out and let's get started.
                            </p>
                        </div>
                    </div>
                </section>

                <div className="decorative-line-container">
                    <div className="decorative-line-bg"></div>
                </div>

                <section className="contact-form-section">
                    <div className="contact-content-wrapper">
                        <form className="contact-form" onSubmit={handleSubmit}>
                            <div className="form-row">
                                <div className="form-group name-group">
                                    <label className="form-label">Name*</label>
                                    <input
                                        type="text"
                                        name="name"
                                        className="form-input"
                                        required
                                        value={formData.name}
                                        onChange={handleChange}
                                    />
                                    <div className="input-underline-image name-underline"></div>
                                </div>
                                <div className="form-group email-group">
                                    <label className="form-label">Email*</label>
                                    <input
                                        type="email"
                                        name="email"
                                        className="form-input"
                                        required
                                        value={formData.email}
                                        onChange={handleChange}
                                    />
                                    <div className="input-underline-image email-underline"></div>
                                </div>
                            </div>

                            <div className="form-group industry-group">
                                <label className="form-label">Your Industry*</label>
                                <input
                                    type="text"
                                    name="industry"
                                    className="form-input"
                                    required
                                    value={formData.industry}
                                    onChange={handleChange}
                                />
                                <div className="input-underline-image full-underline"></div>
                            </div>

                            <div className="form-group program-group">
                                <label className="form-label">Which program are you inquiring about?*</label>
                                <div className="select-container">
                                    <select
                                        name="program"
                                        className="form-select"
                                        required
                                        value={formData.program}
                                        onChange={handleChange}
                                    >
                                        <option value="" disabled>Select an option</option>
                                        <option value="adc">ADC Module</option>
                                        <option value="drugcombination">Drug Combination Module</option>
                                        <option value="lbxai">LBx-AI</option>
                                        <option value="predictbbb">PredictBBB</option>
                                        <option value="withzeta">withZeta</option>
                                        <option value="others">others</option>
                                    </select>
                                    <div className="input-underline-image full-underline"></div>
                                </div>
                            </div>

                            <div className="form-group message-group">
                                <label className="form-label">Message*</label>
                                <textarea
                                    name="message"
                                    className="form-textarea"
                                    required
                                    value={formData.message}
                                    onChange={handleChange}
                                    onInput={(e) => {
                                        e.target.style.height = 'auto';
                                        e.target.style.height = e.target.scrollHeight + 'px';
                                    }}
                                ></textarea>
                                <div className="input-underline-image full-underline"></div>
                            </div>

                            {/* reCAPTCHA Widget */}
                            <div className="form-group recaptcha-group">
                                <div className="g-recaptcha" data-sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}></div>
                            </div>

                            <div className="submit-container">
                                <button type="submit" className="send-button" disabled={isSubmitting}>
                                    {isSubmitting ? 'Sending...' : 'Send'}
                                </button>
                            </div>

                            {status.message && (
                                <div className={`status-message-box status-${status.type}`}>
                                    {status.message}
                                </div>
                            )}
                        </form>
                    </div>
                </section>
            </main>
        </div>
    );
};

export default ContactPage;
